import { camelCase } from "./index";

export const isWeightAudit = (record) => {
  const auditType = (record?.auditType || "").toString().toUpperCase();
  if (auditType && auditType !== "WEIGHT") {
    return false;
  }
  return (
    auditType === "WEIGHT" ||
    record?.bookedWeight != null ||
    record?.auditedWeight != null ||
    (!record?.fieldName && record?.bookedValue == null && record?.auditedValue == null)
  );
};

export const displayAuditValue = (value) =>
  value !== null && value !== undefined && value !== "" ? value : "—";

const AUDIT_FIELD_LABELS = {
  DESTINATION_PINCODE: "Destination Pincode",
  TRAVEL_BY: "Travel By",
};

const AUDIT_TYPE_LABELS = {
  WEIGHT: "Weight",
  DESTINATION_PINCODE: "Destination Pincode",
  TRAVEL_BY: "Travel By",
};

export const formatAuditTypeLabel = (auditType) => {
  const key = (auditType || "").toString().toUpperCase();
  return AUDIT_TYPE_LABELS[key] || auditType || "Weight";
};

export const formatAuditFieldLabel = (fieldName) => {
  if (!fieldName) {
    return "Value";
  }
  const key = fieldName.toString().toUpperCase();
  return AUDIT_FIELD_LABELS[key] || camelCase(fieldName);
};

export const formatAuditTimestamp = (timestamp) => {
  if (!timestamp) {
    return "—";
  }
  return String(timestamp).replace(" ", " | ");
};

export const getWeightDiffNote = (record) => {
  const audited = record?.auditedWeight;
  const booked = record?.bookedWeight;
  if (audited == null || booked == null || audited === 0) {
    return null;
  }
  const pct = ((audited - booked) / audited) * 100;
  const direction = pct >= 0 ? "higher" : "lower";
  return `Audited actual weight is ${direction} by ${Math.abs(pct).toFixed(2)}%.`;
};

export const getFieldAuditNote = (record) => {
  if (record?.bookedValue == null && record?.auditedValue == null) {
    return null;
  }
  return `Changed from ${displayAuditValue(record?.bookedValue)} to ${displayAuditValue(
    record?.auditedValue
  )}.`;
};
